import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../constants/Languages.js';
import {Link} from 'react-router-dom';

//import img
import causesImg from '../assets/icons/arrow-circle-full-yellow.svg';
import sorryImg from '../assets/icons/arrow-circle-full-green.svg';

const Error505Page = ({ clang }) => {
    return (
        <div className="error-server">
            <h2 className="error-page--title">
                {lang[clang].errors.error_500}
                <p className="error-page--code">{lang[clang].errors.error_code} 500</p>
            </h2>
            <div className="error-page--separator"></div>
            <span className="error-page--causes">
                <img className="error-page--causes-img" src={causesImg} alt="" />
                {lang[clang].errors.error_info}
            </span>
            <div className="error-page--what-now-container">
                <p dangerouslySetInnerHTML={{__html: lang[clang].errors.error_500_desc}}></p>
            </div>
            <h3 className="error-page--sorry">
                <img className="error-page--sorry-img" src={sorryImg} alt="" />
                {lang[clang].errors.sorry}
            </h3>
            <div className="error-page--what-now-container">
                <p className="error-page__what-now">{lang[clang].errors.what_now}</p>
                <Link to={`/`} className="error-page--link" title={lang[clang].errors.go_to_homepage}>{lang[clang].errors.go_to_homepage}</Link>
                <span className="error-page--what-now-separator">|</span>
                <span className="error-page__use-map">{lang[clang].errors.use_map}</span>
            </div>
        </div>
    );
};

Error505Page.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(Error505Page);



// WEBPACK FOOTER //
// ./src/components/Error505Page.js